import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

/**
 * Reusable confirmation dialog.
 * Props: isOpen, title, message, confirmText, cancelText, danger, loading,
 *        onConfirm, onCancel
 */
const ConfirmModal = ({
  isOpen,
  title = 'Please confirm',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Modal isOpen={isOpen} toggle={loading ? undefined : onCancel} centered>
    <ModalHeader toggle={loading ? undefined : onCancel}>{title}</ModalHeader>
    <ModalBody>{message}</ModalBody>
    <ModalFooter>
      <Button color="secondary" outline onClick={onCancel} disabled={loading}>
        {cancelText}
      </Button>
      <Button
        color={danger ? 'danger' : 'primary'}
        onClick={onConfirm}
        disabled={loading}
      >
        {loading ? 'Please wait…' : confirmText}
      </Button>
    </ModalFooter>
  </Modal>
);

export default ConfirmModal;
